import { Grid, TextField } from "@mui/material";
import Box from "@mui/material/Box";
import { useDispatch } from "react-redux";
import { addFlashInfo } from "../../store/siteWebSlice";
import { SITEWEB_SERVER_BASE_URL, apiClient } from "../../util/apiClient";
import { errorNotify, successNotify } from "../../util/functions";
import PostDialog from "../components/PostDialog";
import React, { useState, useRef } from "react";
import { IFlashInfoState } from "./interface";

interface IAddProps {
  flashInfoState: IFlashInfoState,
  setFlashInfoState: (x: IFlashInfoState) => void
}


const Add = (props: IAddProps) => {

  //props
  const {
    flashInfoState, setFlashInfoState
  } = props

  //fonctions
  const handleInputChange = (e: any) => {
    const { value, name } = e.target
    setFlashInfoState({ ...flashInfoState, [name]: value })
  }


  return (
    <Box sx={{ flexGrow: 1, width: "100%" }}>
      <Grid
        container
        spacing={2}
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
      >
        <Grid item md={6} xs={12} sm={6}>
          <TextField
            fullWidth
            multiline
            minRows={5}
            size="small"
            name="info"
            label="Information"
            value={flashInfoState.info}
            onChange={handleInputChange}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export const initialState = { info: "" }

const DialogAdd = () => {


  //redux
  const dispatch = useDispatch();

  //hooks
  const [open, setOpen] = useState<boolean>(false)
  const [addLoading, setAddLoading] = useState<boolean>(false)
  const [flashInfoState, setFlashInfoState] = useState<IFlashInfoState>(initialState)

  //Fermer la boite de dialog d'ajout d'une flash info
  const onClose = () => {
    setOpen(false)
  }

  //Ouvrir la boite de dialog d'ajout d'une flash info
  const handleOpenDialog = () => {
    setOpen(true)
  }

  //Enregistrer une flash info
  const handleSave = async (e: any) => {
    try {
      e.preventDefault()
      setAddLoading(true)
      const apiPayload = {
        titreInfo: flashInfoState.info
      }
      const res: any = await apiClient.post(SITEWEB_SERVER_BASE_URL, "/ajouterflashinfo", apiPayload);
      if (res.status === 1) {
        dispatch(addFlashInfo(res.data))
        successNotify("Action effectuée avec succès");
        setAddLoading(false)
        setFlashInfoState(initialState)
      } else {
        errorNotify("Erreur");
        setAddLoading(false)
      }
    } catch (error) {
      console.log("🚀 ~ file: Add.tsx:305 ~ handleActualiteSave ~ error:", error)
    }
  }

  return (
    <PostDialog
      onClose={onClose}
      open={open}
      dialogContent={
        <Add
          flashInfoState={flashInfoState}
          setFlashInfoState={setFlashInfoState}
        />}
      actionFunc={handleSave}
      title="Flash info"
      addLoading={addLoading}
      handleOpenDialog={handleOpenDialog}
    />

  );
};
export default DialogAdd;



